import ToggleSwitch from "app/components/ToggleSwitch/ToggleSwitch";
import { betPanelHelper } from "app/helpers/betPanelHelper";
import { BetBuilderEventsType } from "app/types/betBuilderType";
import { UserType } from "app/types/userType";
import { BetSlipStates } from "app/utils/const";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import BetBuilder from "./BetBuilder";
import BetBuilderCompletedMessage from "./components/BetBuilderCompletedMessage/BetBuilderCompletedMessage";

type Props = {
  betBuilderEvents: BetBuilderEventsType;
  removeBet: (id: number) => void;
  autoCollapseBetBuilder: boolean;
  toggleAutoCollapseAll: () => void;
  user: UserType;
};

const BetBuilderContainer: React.FC<Props> = ({
  betBuilderEvents,
  removeBet,
  toggleAutoCollapseAll,
  autoCollapseBetBuilder,
  user,
}) => {
  const intl = useIntl();
  const hasBetBuilder = Object.values(betBuilderEvents).some(
    betBuilderEvent => betBuilderEvent.betBuilderItems.length > 1
  );

  useEffect(() => {
    // if user toggles the Auto-Collapse Bet Builders button update betPanelManager state
    betPanelHelper.countExpandedCollapsedBetSlips();
  }, [user?.preferences?.autoCollapseBetBuilder]);

  return (
    <div className="bet-builder-bets-container">
      {hasBetBuilder && (
        <ToggleSwitch
          label={intl.formatMessage({ id: "bets-auto-collapse-bet-builder" })}
          isChecked={autoCollapseBetBuilder}
          onToggle={toggleAutoCollapseAll}
          name="autoCollapseBetBuilder"
        />
      )}
      {Object.values(betBuilderEvents).map(betBuilderEvent => {
        // Only show BetBuilder when 2 or more selections added
        if (betBuilderEvent.betBuilderItems.length > 1) {
          if (betBuilderEvent.status === BetSlipStates.FINISHED) {
            return (
              <BetBuilderCompletedMessage betBuilderEvent={betBuilderEvent} />
            );
          }

          return (
            <div
              className={"bet-builder-bet-container__events "}
              key={betBuilderEvent.eventId}
            >
              <BetBuilder
                betBuilderEvent={betBuilderEvent}
                removeBet={(id: number) => {
                  removeBet(id);
                }}
              />
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};
const mapStateToProps = state => ({
  betBuilderEvents: state.betBuilderModel.betBuilderEvents,
  autoCollapseBetBuilder:
    state.userModel.user?.preferences?.autoCollapseBetBuilder || false,
  user: state.userModel.user,
});
const mapDispatchToProps = dispatch => ({
  removeBet: (id: number) => {
    dispatch.betBuilderModel.removeBet({ eventId: id });
  },
  toggleAutoCollapseAll: (ev: React.ChangeEvent<HTMLInputElement>) => {
    const name = ev?.target?.name;
    const value = ev?.target?.checked;
    if (name !== undefined && value !== undefined) {
      dispatch.userModel.setUserPreference({ [name]: value });
    }
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BetBuilderContainer);
